import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Pessoa } from '../models/pessoa.model';
import { LoginPessoa } from '../models/login-pessoa';
import { AuthenticationProfile } from '../authentication/authentication-profile.model';
import { LoginServidor } from '../models/login-servidor';
import { ValidacaoAcesso } from '../models/validacao-acesso.model';
import { AlteracaoSenha } from '../models/alteracao-senha.model';
import { DTO } from '../models/dto/dto';

@Injectable()
export class PessoaService {

  constructor(private httpClient: HttpClient) { }

  GetLoginPessoa(loginPessoa: LoginPessoa): Observable<boolean> {
    return this.httpClient.post<boolean>(`/Pessoa/PostLoginPessoa/`, loginPessoa);
  }

  GetLoginServidor(loginServidor: LoginServidor): Observable<number> {
    return this.httpClient.post<number>(`/Pessoa/PostLoginServidor/`, loginServidor);
  }

  PostValidaAcessoBanca(matricula: string): Observable<boolean> {
    return this.httpClient.post<boolean>(`/Pessoa/PostValidaAcessoBanca/`, matricula);
  }

  PostValidaAcessoBancaEdital(validacaoAcesso: ValidacaoAcesso): Observable<boolean> {
    return this.httpClient.post<boolean>(`/Pessoa/PostValidaAcessoBancaEdital/`, validacaoAcesso);
  }

  GetLoginPessoaAuth(loginPessoa: LoginPessoa): Observable<AuthenticationProfile> {
    return this.httpClient.post<AuthenticationProfile>(`/Pessoa/PostLoginPessoaAuth/`, loginPessoa);
  }

  GetVerificaPessoaByCpf(cpf: string): Observable<boolean> {
    return this.httpClient.get<boolean>(`/Pessoa/GetVerificaPessoa/${cpf}`);
  }

  GetPessoaByCpf(cpf: string): Observable<Pessoa> {
    return this.httpClient.get<Pessoa>(`/Pessoa/GetPessoa/${cpf}`);
  }

  EnviaEmailPessoaByCpf(pessoa: Pessoa): Observable<boolean> {
    return this.httpClient.post<boolean>(`/Pessoa/EnviaEmailPessoa/`, pessoa);
  }

  AlteraSenhaPessoa(alteracaoSenha: AlteracaoSenha): Observable<boolean> {
    return this.httpClient.post<boolean>(`Pessoa/PostAlteraSenha/`, alteracaoSenha);
  }

  Create(pessoa: Pessoa): Observable<boolean> {
    return this.httpClient.post<boolean>(`Pessoa/PostPessoa/`, pessoa);
  }

  Update(pessoa: Pessoa): Observable<boolean> {
    return this.httpClient.put<boolean>(`Pessoa/PutPessoa/`, pessoa);
  }

  UpdateDadosAdicionais(pessoa: Pessoa, concurso: number, numeroInscricao: number): Observable<DTO> {
    return this.httpClient.post<DTO>(`Convocacao/PostDadosAdicionais/` + concurso + '/' + numeroInscricao + '', pessoa);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/pessoa.service.ts